<template>
  <div>
    <h3 class="dashboard-header">Today's Workout</h3>
    <hr>
    <!-- {{ today }} -->
    <!-- {{ day }} -->

    <div v-if="day" class="todays-workout" style="line-height: 1.1;">
      <!-- <h1>hello</h1> -->
      <!-- {{ day.date }} -->
      <!-- https://stackoverflow.com/questions/12851792/why-cant-i-decrease-the-line-height-of-this-text -->
      <!-- <p style="font-weight: 700; margin-bottom: 0.5rem; cursor: pointer;">{{ day.day }}</p> -->
      <!-- <hr style="margin-top: 0.2rem; margin-bottom: 0.25rem;"> -->
      <!-- <small style="color: grey;">{{ day.date }}</small> -->
      <small style="">{{ today }}</small>
      <h4 v-if="day.workout" style="margin-top: 8px; font-weight: 700;">{{ day.workout }}</h4>
      <div style="margin-bottom: 4px;">
        <p class="day-info" v-if="day.distance && (day.workout != 'Intensity')">Distance: {{ day.distance | noDecimals }}{{ distanceUnits }}</p>
        <p class="day-info" v-if="day.workout == 'Intensity'">{{day.intensity_reps}} x {{ day.distance * 1000 }}m</p>
        <p class="day-info" v-if="day.pace_minutes || day.pace_seconds">Pace: {{ day.pace_minutes }}:{{ day.pace_seconds | twoDigits }}</p>
        <p class="day-info" v-if="day.rest_minutes || day.rest_seconds">Rest: {{ day.rest_minutes }}:{{ day.rest_seconds | twoDigits }}</p>
        <p class="day-info" v-if="(day.workout != 'Rest') && (day.time_hours || day.time_minutes || day.time_seconds)">Time: <span v-if="day.time_hours">{{ day.time_hours }}</span><span v-if="!day.time_hours">0</span>:{{ day.time_minutes | twoDigits }}:{{ day.time_minutes | twoDigits }}</p>

        <p class="day-info" v-if="day.target_hr && (day.workout != 'Fartlek')">Target HR: {{ day.target_hr }}</p>
        <p class="day-info" v-if="day.target_hr && (day.workout == 'Fartlek')">Net HR: {{ day.target_hr }}</p>
      </div>

      <div>
        <small style="line-height: 1.1" v-if="!day.filled">{{ day.comments }}</small>
        <small style="" v-if="day.filled">{{ day.notes }}</small>
      </div>
    </div>

    <div v-if="noWorkout || (day.workout == '')">
      <h5 class="mt-2" style="font-weight: ;">You don't have a workout planned for today!</h5>
      <!-- <small>Add to your training plan</small> -->
      <router-link to="/trainingplan" class="btn btn-primary mt-2">Add to Training Plan</router-link>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    props: ['user'],
    data () {
      return {
        user: null,
        today: null,
        day: {},
        noWorkout: false,
      }
    },
    created() {
      // this.getUser()
      this.getToday()
    },
    methods: {
      getUser () {
        this.$store.dispatch('getUser').then(() => { // Lecture 360
          this.user = this.$store.getters.user
          // console.log(this.$store.getters.user)

          // let today = new Date()
          // this.today = today.toDateString()

          this.getToday();
        })
      },
      getToday() {
        // The TargetRaces component is a good reference for date related manipulation
        let today = new Date()
        this.today = today.toDateString() // Return the date in a human readable format without the time

        // https://tecadmin.net/get-current-date-time-javascript/
        let yearNow = today.getFullYear()
        // console.log(yearNow)
        let monthNow = today.getMonth() + 1
        monthNow = ("0" + monthNow).slice(-2);
        // console.log(monthNow)
        let dayNow = today.getDate()
        dayNow = ("0" + dayNow).slice(-2);
        // console.log(dayNow)
        // dayNow = 14

        let todayDate = yearNow + '-' + monthNow + '-' + dayNow // This is the date format used in Django
        // console.log(todayDate)

        // Try to get the workout for this user for today
        axios.get('/api/days/?user='.concat(this.user.id.toString()).concat('&date=').concat(todayDate))
          .then(res => {
            console.log(res)
            // this.day = res.data
            // console.log(res.data.length)

            if (res.data.length === 0) {
              this.noWorkout = true
            }
            else {
              this.day = res.data[0]
            }

            // for (var day in this.days) {
            //   console.log(this.days[day].date)
            // }
          })
          .catch(error => console.log(error))
      }
    }
  }
</script>

<style>

  p.day-info {
    margin-bottom: 6px;
    font-weight: 600;
  }

</style>



// WEBPACK FOOTER //
// src/components/myrundash/dashboard/TodaysWorkout.vue